import { render, staticRenderFns } from "./ShortUserCard.vue?vue&type=template&id=70105c3e&"
import script from "./ShortUserCard.vue?vue&type=script&lang=ts&"
export * from "./ShortUserCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports